/* eslint-disable camelcase */
import React from "react";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { resetError } from "../../actions/errors";
import PinModal from "../../components/pin";
import { createDstRegion } from "../../actions/dst-regions";
import { dstRegionsPath } from "../../routes";
import { MONTH_NAMES } from "../../constants/month-names";
import { WEEKDAY_NAMES } from "../../constants/weekday-names";
import { WEEKDAY_ORDINALS } from "../../constants/weekday-ordinal";

const numericColumns = [
  "start_month",
  "start_weekday",
  "start_weekday_ordinal",
  "end_month",
  "end_weekday",
  "end_weekday_ordinal",
];
class DstRegionNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.requestSubmit = this.requestSubmit.bind(this);
    this.failedSubmit = this.failedSubmit.bind(this);
  }

  handleChange(e, name) {
    const { value } = e.target;
    if (numericColumns.includes(name.toLowerCase())) {
      this.setState({ [name]: Number(value) });
    } else {
      this.setState({ [name]: value });
    }
  }

  requestSubmit(e) {
    e.preventDefault();
    this.setState({
      submitted: true,
    });
  }

  failedSubmit() {
    this.setState({
      submitted: false,
    });
  }

  handleSubmit() {
    const { createDstRegionAction, goToList, resetErrorAction } = this.props;
    resetErrorAction();
    const {
      display_name,
      start_month,
      start_weekday,
      start_weekday_ordinal,
      end_month,
      end_weekday,
      end_weekday_ordinal,
    } = this.state;
    const body = {
      display_name,
      start: {
        month: start_month,
        weekday: start_weekday,
        weekday_ordinal: start_weekday_ordinal,
      },
      end: {
        month: end_month,
        weekday: end_weekday,
        weekday_ordinal: end_weekday_ordinal,
      },
    };
    Object.keys(body).forEach(
      (key) => body[key] === undefined && delete body[key],
    );

    createDstRegionAction({ body: JSON.stringify(body) }).then(() => {
      goToList();
    });
  }

  render() {
    const {
      display_name,
      start_month,
      start_weekday,
      start_weekday_ordinal,
      end_month,
      end_weekday,
      end_weekday_ordinal,
      submitted,
    } = this.state;
    const { goToList } = this.props;
    return (
      <div className="animated fadeIn">
        {submitted && (
          <PinModal
            successSubmit={this.handleSubmit}
            failedSubmit={this.failedSubmit}
          />
        )}
        <Row>
          <Col lg={6}>
            <Card>
              <Form onSubmit={(e) => this.requestSubmit(e)}>
                <CardHeader>
                  <strong>{"New DST Region"}</strong>
                </CardHeader>
                <CardBody>
                  <FormGroup>
                    <Label htmlFor="display_name">Name</Label>
                    <Input
                      id="display_name"
                      type="text"
                      placeholder="Enter Name"
                      invalid={submitted && display_name === ""}
                      onChange={(e) => this.handleChange(e, "display_name")}
                      required
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="start_month">Start Month</Label>
                    <Input
                      type="select"
                      name="start_month"
                      id="start_month"
                      invalid={submitted && !MONTH_NAMES[start_month]}
                      onChange={(e) => this.handleChange(e, "start_month")}
                      required
                    >
                      <option value={""}>Select an option...</option>
                      {MONTH_NAMES.map((month, index) => (
                        <option key={month} value={index}>
                          {month}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="start_weekday">Start Weekday</Label>
                    <Input
                      type="select"
                      name="start_weekday"
                      id="start_weekday"
                      invalid={submitted && !WEEKDAY_NAMES[start_weekday]}
                      onChange={(e) => this.handleChange(e, "start_weekday")}
                      required
                    >
                      <option value={""}>Select an option...</option>
                      {WEEKDAY_NAMES.map((item, index) => (
                        <option key={item} value={index}>
                          {item}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="start_weekday_ordinal">
                      Start Weekday Ordinal
                    </Label>
                    <Input
                      type="select"
                      name="start_weekday_ordinal"
                      id="start_weekday_ordinal"
                      invalid={
                        submitted &&
                        !WEEKDAY_ORDINALS.find(
                          (item) => item.value === start_weekday_ordinal,
                        )
                      }
                      onChange={(e) =>
                        this.handleChange(e, "start_weekday_ordinal")
                      }
                      required
                    >
                      <option value={""}>Select an option...</option>
                      {WEEKDAY_ORDINALS.map((item) => (
                        <option key={item.value} value={item.value}>
                          {item.description}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="end_month">End Month</Label>
                    <Input
                      type="select"
                      name="end_month"
                      id="end_month"
                      invalid={submitted && !MONTH_NAMES[end_month]}
                      onChange={(e) => this.handleChange(e, "end_month")}
                      required
                    >
                      <option value={""}>Select an option...</option>
                      {MONTH_NAMES.map((month, index) => (
                        <option key={month} value={index}>
                          {month}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="end_weekday">End Weekday</Label>
                    <Input
                      type="select"
                      name="end_weekday"
                      id="end_weekday"
                      invalid={submitted && !WEEKDAY_NAMES[end_weekday]}
                      onChange={(e) => this.handleChange(e, "end_weekday")}
                      required
                    >
                      <option value={""}>Select an option...</option>
                      {WEEKDAY_NAMES.map((item, index) => (
                        <option key={item} value={index}>
                          {item}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="end_weekday_ordinal">
                      End Weekday Ordinal
                    </Label>
                    <Input
                      type="select"
                      name="end_weekday_ordinal"
                      id="end_weekday_ordinal"
                      invalid={
                        submitted &&
                        !WEEKDAY_ORDINALS.find(
                          (item) => item.value === end_weekday_ordinal,
                        )
                      }
                      onChange={(e) =>
                        this.handleChange(e, "end_weekday_ordinal")
                      }
                      required
                    >
                      <option value={""}>Select an option...</option>
                      {WEEKDAY_ORDINALS.map((item) => (
                        <option key={item.value} value={item.value}>
                          {item.description}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </CardBody>
                <CardFooter>
                  <Button type="submit" size="sm" color="primary">
                    Create
                  </Button>{" "}
                  <Button onClick={() => goToList()} size="sm" color="danger">
                    Cancel
                  </Button>
                </CardFooter>
              </Form>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createDstRegionAction: (body) => createDstRegion(body),
      goToList: () => push(`/${dstRegionsPath}`),
      resetErrorAction: () => resetError(),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DstRegionNew);
